import type { IconData } from '@stacksjs/iconify-core'

export const contentPin: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m9 0l7 7l-5 3v6l-4.5-4.5L2 16H0v-2l4.5-4.5L0 5h6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentPin
